import { forwardRef, HTMLAttributes, ReactNode } from 'react'
import { Wrapper, Label, FieldWrapper, Field, Resizer, Error } from './_styles'

interface TextareaProps extends HTMLAttributes<HTMLTextAreaElement> {
  value?: string
  label?: string
  after?: ReactNode
  hasError?: boolean
  height?: number
  errorText?: string
  disabled?: boolean
  readOnly?: boolean
  placeholder?: string
  maxLength?: number
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    const {
      label,
      after,
      hasError,
      height,
      errorText = '',
      maxLength,
      ...rest
    } = props

    return (
      <Wrapper>
        {label && <Label disabled={rest.disabled}>{label}</Label>}
        <FieldWrapper readOnly={rest.readOnly}>
          <Field
            $height={height}
            $hasError={hasError}
            maxLength={maxLength}
            {...rest}
            ref={ref}
          />
          <Resizer disabled={rest.disabled} readOnly={rest.readOnly} />
          {after}
        </FieldWrapper>
        {hasError && errorText && <Error>{errorText}</Error>}
      </Wrapper>
    )
  }
)

export default Textarea
